import { errorMessage } from "@lumora/bridge";
import { ViewModel } from "../mvvm/ViewModel.js";
/** Display order of key prefixes; unknown prefixes land in "other" last. */
export const CONFIG_GROUP_ORDER = ["limits", "stripe", "payroll", "contact", "cors"];
/** Drives the Lumora console Settings panel over the platform config admin API. */
export class PlatformConfigViewModel extends ViewModel {
    client;
    constructor(client) {
        super({ entries: [], loading: false, error: null, errorKey: null, savingKey: null, history: {} });
        this.client = client;
    }
    async load() {
        await this.run(async () => {
            const entries = await this.client.listPlatformConfig();
            this.setState({ entries, errorKey: null });
        }, "Failed to load settings.");
    }
    async save(key, value) {
        this.setState({ savingKey: key, error: null, errorKey: null });
        try {
            const updated = await this.client.setPlatformConfig(key, value);
            this.setState({
                entries: this.state.entries.map((x) => (x.key === key ? updated : x)),
                savingKey: null,
            });
        }
        catch (err) {
            this.setState({
                savingKey: null,
                error: errorMessage(err, "Failed to save setting."),
                errorKey: key,
            });
        }
    }
    async loadHistory(key) {
        try {
            const rows = await this.client.getPlatformConfigHistory(key, 50);
            this.setState({ history: { ...this.state.history, [key]: rows } });
        }
        catch (err) {
            this.setState({ error: errorMessage(err, "Failed to load history."), errorKey: key });
        }
    }
    /** Entries bucketed by key prefix: limits, stripe, payroll, contact, cors, then other. */
    groups() {
        const buckets = new Map();
        for (const entry of this.state.entries) {
            const prefix = entry.key.split(".")[0] ?? "";
            const name = CONFIG_GROUP_ORDER.includes(prefix) ? prefix : "other";
            const list = buckets.get(name) ?? [];
            list.push(entry);
            buckets.set(name, list);
        }
        return [...CONFIG_GROUP_ORDER, "other"]
            .filter((name) => buckets.has(name))
            .map((name) => ({ name, entries: buckets.get(name) }));
    }
}
//# sourceMappingURL=PlatformConfigViewModel.js.map